import { lazy } from 'react';
import Loadable from 'components/Loadable';

// /landing is the marketing home page. Everything about an account (sign in, create account, forgot/reset
// password, email verification) is one separate page; the route only decides which card it opens on.
const LandingPage = Loadable(lazy(() => import('views/landing/LandingPage')));
const AccountPage = Loadable(lazy(() => import('views/landing/AccountPage')));
const SharedViewPage = Loadable(lazy(() => import('views/landing/SharedViewPage')));

const AuthRoutes = {
  path: '/',
  children: [
    { path: 'landing', element: <LandingPage /> },
    { path: 'shared/:token', element: <SharedViewPage /> },
    { path: 'auth/login', element: <AccountPage start="login" /> },
    { path: 'auth/register', element: <AccountPage start="register" /> },
    { path: 'auth/forgot-password', element: <AccountPage start="forgot" /> },
    { path: 'verify-email/:token', element: <AccountPage start="verify" /> },
    { path: 'reset-password/:token', element: <AccountPage start="reset" /> }
  ]
};

export default AuthRoutes;
